import { LayoutPicker } from "../../layoutpicker/layoutpicker"
import { ThemePresetPicker } from "../../themepresetpicker/themepresetpicker"

export function ThemePresetStage(props) {
    return <>
    <h1>Choose Layout</h1>
        <LayoutPicker theme={props.theme} />
    <h1>Choose Theme</h1>
        <ThemePresetPicker theme={props.theme} />
    </>
}